const ROEA = [
    {id: "0", value: "ROE"},    
    {id: "1", value: "ROA"},     
  ];  
  
  export default ROEA